/* assets/header-terral.js */
/* Header Terral — burger + dropdowns accesibles */

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header-terral");
  if (!header) return;

  const burger = header.querySelector(".header-terral__burger");
  const menu = header.querySelector(".header-terral__menu");

  const closeAllSubmenus = () => {
    header.querySelectorAll(".header-terral__menu-item.has-submenu").forEach(li => {
      li.classList.remove("is-open");
      const btn = li.querySelector(".header-terral__menu-link[aria-expanded]");
      if (btn) btn.setAttribute("aria-expanded", "false");
    });
  };

  const closeMenu = () => {
    if (!menu) return;
    menu.classList.remove("is-open");
    if (burger) burger.setAttribute("aria-expanded", "false");
    closeAllSubmenus();
  };

  // Burger
  if (burger && menu) {
    burger.addEventListener("click", () => {
      const isOpen = menu.classList.toggle("is-open");
      burger.setAttribute("aria-expanded", isOpen ? "true" : "false");

      // al abrir, cerramos submenus
      if (!isOpen) closeAllSubmenus();
    });
  }

  // Toggle submenus (solo en items con hijos)
  header.querySelectorAll(".header-terral__menu-item.has-submenu > .header-terral__menu-link").forEach(btn => {
    btn.addEventListener("click", (e) => {
      // es un botón (o link role=button) => no navegar
      e.preventDefault();

      const li = btn.closest(".header-terral__menu-item");
      if (!li) return;

      const expanded = btn.getAttribute("aria-expanded") === "true";

      // cerrar otros
      closeAllSubmenus();

      // abrir actual si estaba cerrado
      li.classList.toggle("is-open", !expanded);
      btn.setAttribute("aria-expanded", expanded ? "false" : "true");
    });
  });

  // Cerrar al click fuera
  document.addEventListener("click", (e) => {
    if (!header.contains(e.target)) {
      closeMenu();
    }
  });

  // Cerrar con ESC
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeMenu();
  });

  // En mobile: si haces click en un link normal, cerrar menú
  header.querySelectorAll(".header-terral__submenu-link, .header-terral__menu-link.is-link").forEach(a => {
    a.addEventListener("click", () => {
      closeMenu();
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const switcher = document.querySelector('.header-terral__lang-switcher');
  if (!switcher) return;

  const toggleBtn = switcher.querySelector('.lang-switch__current');
  const dropdown  = switcher.querySelector('.lang-switch__list');

  if (!toggleBtn || !dropdown) return;

  // Abrir / cerrar al hacer click en la bandera activa
  toggleBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    switcher.classList.toggle('is-open');
  });

  // Cerrar si se hace click fuera
  document.addEventListener('click', (e) => {
    if (!switcher.contains(e.target)) {
      switcher.classList.remove('is-open');
    }
  });

  // Cerrar al pulsar ESC (accesibilidad)
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      switcher.classList.remove('is-open');
    }
  });
});
